import { render, staticRenderFns } from "./DiscussionTarget.vue?vue&type=template&id=1bfebd67&"
import script from "./DiscussionTarget.vue?vue&type=script&lang=js&"
export * from "./DiscussionTarget.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionTarget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports